import React from 'react';
import { useTranslation, Trans } from 'react-i18next';  // Import translation hook and Trans component

const CookiesPolicy = () => {
  const { t } = useTranslation();  // Get the translation function

  return (
    <div className="cookies-policy">
      <h1>{t('cookie_policy_title')}</h1>
      <p><strong>{t('effective_from')}</strong> 20.01.2025</p>

      <p>{t('cookies_intro')}</p>

      <h2>{t('what_are_cookies_title')}</h2>
      <p>{t('what_are_cookies')}</p>

      <h2>{t('types_of_cookies_title')}</h2>
      <p>{t('types_of_cookies_intro')}</p>
      <ul>
        <li>
          <strong>{t('mandatory_cookies_title')}</strong>: {t('mandatory_cookies')}
        </li>
      </ul>

      <h2>{t('how_to_manage_cookies_title')}</h2>
      <p>
        {t('how_to_manage_cookies_intro')}{' '}
        <a href="https://www.aboutcookies.org/" target="_blank" rel="noopener noreferrer">
          {t('cookie_management_website')}
        </a>
      </p>

      <h2>{t('changes_to_cookie_policy_title')}</h2>
      <p>{t('changes_to_cookie_policy')}</p>

      <h2>{t('contact_title')}</h2>
      <p>{t('contact_intro')}</p>
      <ul>
        <li><strong>{t('nostr_label')}:</strong> npub17yh89gqvkcck494vag8cwep4ah7g8gwe54ussy4vhltxls8gzc5qwrfek5</li>
      </ul>
    </div>
  );
};

export default CookiesPolicy;
